import React from "react";
import "./Hero.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faXTwitter,
  faLinkedinIn,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons";

const Hero = () => {
  return (
    <div className="hero-container hero-padding">
      <div className="social-sidebar">
        <div className="line"></div>
        <div className="icons">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-hero"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-hero "
          >
            <FontAwesomeIcon icon={faXTwitter} />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-linkedin"
          >
            <FontAwesomeIcon icon={faLinkedinIn} />
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-hero"
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
        </div>
        <div className="line"></div>
      </div>
      <div className="hero-content">
        <div className="hero-text h-width">
          <h2>Accurate Business Valuation Services</h2>
          <h1>Unlock Your</h1>
          <h1>True Company Value</h1>
          <p>
            At Clybourne, we simplify business valuation-delivering fast,
            affordable, and accurate company valuations to empower growth with
            clarity.
          </p>
          <div className="hero-buttons">
            <button className="btn-pri">Let’s Talk!</button>
            <button className="btn-secondary">Buy Now</button>
          </div>
          <div className="watch-demo">
            <button className="demo-button">
              <span className="watch-button">▶</span>
            </button>
            Watch Demo
          </div>
        </div>
        <div className="hero-image">
          <img
            src="/assets/images/Hero/Vector.png"
            alt="Business Growth Illustration"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
